export default __webpack_public_path__ + "static/media/Padron_6000Open.e0fce11c.jpg";